import { ProAccount } from '@front/common/src/types/commons';

export const isNew = (account: ProAccount | null | undefined) => !!account && account.pro_status === 'New';

export const isClosed = (account: ProAccount | null | undefined) => !!account && account.pro_status === 'Closed';

export const isProOpen = (account: ProAccount | null | undefined) => !!account && account.pro_status === 'Open';

export const isAutoEntrepreneur = (account: ProAccount | null | undefined) =>
  !!account && !!account.auto_entrepreneur;

export const isProQualified = (proAccount: ProAccount) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { status_detail, pro_status } = proAccount;
  if (!status_detail || !pro_status) return false;
  return ['New', 'Open'].includes(pro_status) && ['Qualified', 'Onboarding Test'].includes(status_detail);
};
